import { VehiclePicker } from './VehiclePicker';
import { mountCartBadge } from '../Cart/StorefrontCart';
import { mountWishlistBadge } from '../Wishlist/WishlistClient';

/**
 * Layout-level entry point for every storefront page.
 *  - Mounts the VehiclePicker into #sf-vehicle-slot
 *  - Mounts the cart badge updater on #sf-cart-count
 *  - Mounts the wishlist badge updater on #sf-wishlist-count
 *  - Wires the header search field's clear control (#35984)
 *
 * Loaded once by _StorefrontLayout.cshtml. All mounts no-op gracefully
 * if their target elements aren't on the page.
 */
function mount(): void {
    const slot = document.getElementById('sf-vehicle-slot');
    if (slot) new VehiclePicker(slot);

    mountCartBadge();
    mountWishlistBadge();
    wireHeaderSearchClear();
}

/**
 * The header search field's value/clear-button visibility is rendered server-side
 * from the current ?search= query string (see _StorefrontLayout.cshtml), so it stays
 * correct across full-page navigation without any client-side state. The clear button
 * just needs to strip `search` from the current URL (keeping any other query params,
 * e.g. a category selected client-side on the Browse page) and reload.
 */
function wireHeaderSearchClear(): void {
    const btn = document.querySelector('.sf-header-search-clear');
    if (!btn) return;
    btn.addEventListener('click', () => {
        const params = new URLSearchParams(window.location.search);
        params.delete('search');
        const qs = params.toString();
        window.location.href = window.location.pathname + (qs ? `?${qs}` : '');
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
} else {
    mount();
}

export default {};
